import { cn } from '@/lib/utils';
import { EyeClosedIcon, EyeOpenIcon } from '@radix-ui/react-icons';
import { ComponentType, useState } from 'react';
import { Control } from 'react-hook-form';
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../ui/form';
import { Input, InputProps } from '../ui/input';

interface InputControlProps extends InputProps {
  control?: Control<any> | any;
  name: string;
  label?: string | null;
  labelClass?: string;
  placeholder?: string | any;
  description?: string;
  required?: boolean;
  isNumber?: boolean;
  maxLength?: number;
  notRequired?: boolean;
  withoutDescription?: boolean;
}

export const InputControl: ComponentType<InputControlProps> = ({
  control,
  label,
  description,
  name,
  className,
  labelClass,
  type: inputType,
  required,
  isNumber,
  maxLength,
  notRequired,
  withoutDescription,
  ...rest
}) => {
  const [type, setType] = useState(inputType);

  const onSetType = () => {
    if (type === 'text') {
      setType('password');
    } else {
      setType('text');
    }
  };
  const numberMask = (value: string) => {
    const cleaned = value.replace(/[^0-9.]/g, '');
    const parts = cleaned.split('.');
    if (parts.length > 2) {
      return parts[0] + '.' + parts.slice(1).join('');
    }

    return cleaned;
  };

  return (
    <FormField
      control={control}
      name={name}
      render={({ field: { value, onChange, ...field } }) => (
        <FormItem className={cn(className, 'relative')}>
          {label && (
            <FormLabel className={labelClass}>
              {label} {required && <span className={cn('text-red')}>*</span>}
            </FormLabel>
          )}
          <FormControl>
            <div className="relative">
              <Input
                {...rest}
                {...field}
                required={false}
                value={value ?? ''}
                className={cn(
                  className,
                  'w-full rounded-lg border-gray-300 bg-white ',
                )}
                type={type}
                maxLength={maxLength}
                onChange={(e) => {
                  if (isNumber) {
                    const maskedValue = numberMask(e.target.value);
                    if (maxLength && maskedValue.length > maxLength) {
                      return;
                    }

                    const num = Number(maskedValue);
                    if (rest.max !== undefined && num > Number(rest.max)) {
                      return;
                    }
                    if (rest.min !== undefined && num < Number(rest.min)) {
                      return;
                    }

                    onChange(maskedValue);
                  } else {
                    onChange(e);
                  }
                }}
              />
              {inputType === 'password' ? (
                <a
                  className="absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer"
                  onClick={onSetType}
                >
                  {type === 'text' ? <EyeOpenIcon /> : <EyeClosedIcon />}
                </a>
              ) : null}
            </div>
          </FormControl>
          {withoutDescription ? null : (
            <div className="absolute -bottom-[18px] right-0">
              {description && <FormDescription>{description}</FormDescription>}
              {!notRequired && <FormMessage />}
            </div>
          )}
        </FormItem>
      )}
    />
  );
};
